import { TASK_NAMES, TASK_STATUS, } from "./getTasks.js";
export const getTaskDisplayOrdering = (tasks) => {
    const allTasks = [
        ...tasks.currentTasks,
        ...tasks.pendingApproval,
        ...tasks.completedTasks,
        ...tasks.futureTasks,
    ];
    const taskNameDisplayOrder = [
        [TASK_NAMES.addMembers, TASK_NAMES.signMemberships],
        [TASK_NAMES.electBoard],
        [TASK_NAMES.signConstituentMeeting, TASK_NAMES.constituentMeeting],
        [TASK_NAMES.annualReport],
        [TASK_NAMES.signAnnualMeeting, TASK_NAMES.annualMeeting],
    ];
    return taskNameDisplayOrder.flatMap((names) => {
        const task = allTasks.find((item) => names.includes(item.name));
        return task ? [task] : [];
    });
};
export const getRegistrationTaskDisplayOrdering = (tasks) => {
    const names = [
        TASK_NAMES.addPlayers,
        TASK_NAMES.addPlayersNoClassSize,
        TASK_NAMES.classList,
        TASK_NAMES.teamPlayerMembershipsSigned,
        TASK_NAMES.teamPlayerMembershipsApproved,
        TASK_NAMES.breakWeeks,
    ];
    const allTasks = [
        ...tasks.currentTasks,
        ...tasks.pendingApproval,
        ...tasks.futureTasks,
        ...tasks.completedTasks,
    ];
    return names.flatMap((name) => allTasks.filter((task) => task.name === name));
};
export const getClubTaskStatus = (tasks) => {
    if (!tasks)
        return TASK_STATUS.future;
    const items = getTaskDisplayOrdering(tasks);
    if (items.some(({ status }) => status === TASK_STATUS.current)) {
        return TASK_STATUS.current;
    }
    if (items.some(({ status }) => status === TASK_STATUS.pendingApproval)) {
        return TASK_STATUS.pendingApproval;
    }
    if (items.some(({ status }) => status === TASK_STATUS.future)) {
        return TASK_STATUS.future;
    }
    return TASK_STATUS.completed;
};
//# sourceMappingURL=statusTasks.js.map